import React, { useEffect, useState } from "react";
import "./DownloadPage.scss";

const DownloadPage = () => {
  const [showFallback, setShowFallback] = useState(false);
  const [redirecting, setRedirecting] = useState(true);
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    function redirectToStore() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isAndroid = /android/i.test(ua);

      if (isIOS) {
        setPlatform("ios");
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_IOS_STORE_URL;
        }, 1500);
      } else if (isAndroid) {
        setPlatform("android");
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_ANDROID_STORE_URL;
        }, 1500);
      } else {
        setRedirecting(false);
        setShowFallback(true);
      }
    }

    redirectToStore();
  }, []);

  return (
    <div className="DownloadPage">
      <div className="DownloadPage__card">

        <div className="DownloadPage__logo">
          <img src="/logo.svg" alt="Backporch" />
        </div>

        <div className="DownloadPage__divider" />

        {redirecting && !showFallback && (
          <div className="DownloadPage__redirecting">
            <div className="DownloadPage__spinner" />
            <p className="DownloadPage__redirect-text">
              Taking you to the {platform === "ios" ? "App Store" : "Google Play"}...
            </p>
            <p className="DownloadPage__redirect-sub">
              If nothing happens,{" "}
              <a href={platform === "ios" ? process.env.REACT_APP_IOS_STORE_URL : process.env.REACT_APP_ANDROID_STORE_URL}>
                click here
              </a>
            </p>
          </div>
        )}

        {showFallback && (
          <>
            <p className="DownloadPage__tagline">Your property, all in one place.</p>
            <p className="DownloadPage__sub">Download the app to get started.</p>
            <div className="DownloadPage__badges">
              <a href={process.env.REACT_APP_IOS_STORE_URL} target="_blank" rel="noreferrer" className="DownloadPage__badge-link">
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                />
              </a>
              <a href={process.env.REACT_APP_ANDROID_STORE_URL} target="_blank" rel="noreferrer" className="DownloadPage__badge-link">
                <img
                  src="/google-play-badge.png"
                  alt="Get it on Google Play"
                  className="DownloadPage__badge-android"
                />
              </a>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default DownloadPage;
